import $ from 'jquery';


function init() {

  if( $('.navbar').length > 0 ) {
    const $dropdownButtons = $('.navbar__item--link-container');

    $dropdownButtons.on('click', function () {
      const $dropDownItem = $(this).next('.navbar__dropdown');
      const $navItem = $(this).parent('.navbar__item');
      const hasDropDown = $dropDownItem.length > 0;

      _closeDropdown($('.navbar__item').not($navItem), $dropdownButtons); //reset all opened dropdowns

      if(hasDropDown && $navItem.length) {
        _toggleOpen($navItem, $(this));
        _toggleTabindex($navItem, $dropDownItem)
      }
    });

    $('.js-mobile-nav-toggle').on('click', () => {
      //we have to pass all instances of .js-mobile-nav-toggle to aria-expanded work correctly
      _toggleOpen($('.navbar__main-nav'), $('.js-mobile-nav-toggle'));
    });

    $('body').on('click', (e) => {
      const elementInNav = $(e.target).closest('.navbar__item').length > 0;

      if(!elementInNav) {
        _closeDropdown($('.navbar__item'), $dropdownButtons);
      }
    });

  }
}

/**
 * Open or close dropdown
 * @param {JQuery} $element dropdown parent
 * @param {JQuery} $button button/buttons that activates dropdown
 */
function _toggleOpen($element, $button) {
  if (!$element.hasClass('open')) {
    $element.addClass('open');
    $button.attr('aria-expanded','true');
  } else {
    _closeDropdown($element, $button);
  }
}

/**
/**
 * Open or close dropdown
 * @param {JQuery} $element dropdown/dropdowns parent
 * @param {JQuery} $button button/buttons that activates dropdown
 */
function _closeDropdown($element, $button) {
  $element.removeClass('open');
  $button.attr('aria-expanded','false');
}

function _toggleTabindex($navItem, $dropDownItem) {

  const $dropdownLinks = $dropDownItem.find('a');

  if($navItem.hasClass('open')) {
    $dropdownLinks.attr('tabindex', 0);
  } else {
    $dropdownLinks.attr('tabindex', -1);
  }

}

export default { init };
export { init };
